module.exports = __webpack_public_path__ + "img/img11.79c33c22.png";